import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import get from 'lodash/get'
import { SearchPage as Page } from './SearchPage'
import { AppStateType } from '../../reducers'
import { selectSearch } from '../../selectors/search'
import { selectGroupById } from '../../selectors/groups'

const mapStateToProps = (state: AppStateType, ownProps) => ({
  search: selectSearch(state),
  group: selectGroupById(get(ownProps, 'match.params.groupId', ''))(state),
  groupsLoading: state.groups.isLoading,
  groupsLoaded: state.groups.isLoaded,
})

export const SearchPage = withRouter(
  connect(mapStateToProps)(Page)
) as React.FC<{}>
